import type { GenerateLinkDto, GenerateLinkRespondentDto, RespondentSurveyLinkDto, SurveyCriteriaDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GenerateSurveyLinkService {
  apiName = 'Default';
  

  createSurveyRespondent = (key: string, request: GenerateLinkRespondentDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RespondentSurveyLinkDto>({
      method: 'POST',
      url: `/api/wellbeing/surveys-link/${key}`,
      body: request,
    },
    { apiName: this.apiName,...config });
  

  generateLink = (tenantKey: string, companyKey: string, surveyKey: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GenerateLinkDto>({
      method: 'GET',
      url: `/api/wellbeing/surveys-link/generate/${tenantKey}/${companyKey}/${surveyKey}`,
    },
    { apiName: this.apiName,...config });
  

  getSurveyCriteria = (token: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SurveyCriteriaDto[]>({
      method: 'GET',
      url: `/api/wellbeing/surveys-link/selected-criterias/${token}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
